export const NO_VALUE_PLACEHOLDER = "—";
export const showValue = <T>(value: T): T | typeof NO_VALUE_PLACEHOLDER =>
  value ? value : NO_VALUE_PLACEHOLDER;
